import { z } from 'zod'

export const establishmentInfrastructureCreateSchema = z.object({
  display_name: z
    .string()
    .trim()
    .min(3, { message: 'Tamanho mínimo: 3 caracteres' })
    .max(64, { message: 'Tamanho máximo: 64 caracteres' }),
})

export type EstablishmentInfrastructureValidationSchema = z.infer<typeof establishmentInfrastructureCreateSchema>
